import {CsvFileIcon} from '@modifi/ui'
import {
  ApiIcon,
  BFIcon,
  BlogIcon,
  BoostCashFlowIcon,
  CareerIcon,
  CompanyIcon,
  ContactUsIcon,
  ExistingFinancingIcon,
  GlobeIcon,
  HelpIcon,
  LetterIcon,
  MoneyIcon,
  MultipleDocsIcon,
  NewsIcon,
  PayforIcon,
  PeopleIcon,
  PinLocationIcon,
  RegionIcon,
  RiskIcon,
  SFIcon,
  ShipmentIcon,
  TradeIcon,
  VerifiedUserIcon,
  HandShake,
} from '../assets/icons'

import {
  AddYourOrder,
  BoostYourLiquidity,
  BuyerPaysModifi,
  CnBadge,
  EasyAndFast,
  FirstTradeFree,
  GrowTogether,
  GrowYourBusiness,
  ImproveEveryDay,
  MakeCustomersHappy,
  MakeItHappen,
  ModifiPaysSeller,
  NoCollateral,
  NoPaperwork,
  OwnYourActions,
  PartnersAreFriends,
  PaymentExtensions,
  PaymentFlexibility,
  ProductsExtend,
  ProductsOrder,
  ProductsPayment,
  ProductsPayout,
  ProductsRegister,
  ProductsRepayment,
  ProductsShipment,
  PushTheBoundaries,
  QuickAndEasy,
  Register,
  RiskCoverage,
  ShipmentOfGoods,
  StraightTalking,
  ThereForYou,
  Transparent,
} from '../assets/graphics/graphic-icons'

export const iconMap: Record<string, any> = {
  'file-icon': CsvFileIcon,
  'add-your-order-icon': AddYourOrder,
  'api-icon': ApiIcon,
  'boost-your-liquidity-icon': BoostYourLiquidity,
  'buyer-pays-modifi-icon': BuyerPaysModifi,
  'bf-icon': BFIcon,
  'blog-icon': BlogIcon,
  'boost-cash-flow-icon': BoostCashFlowIcon,
  'career-icon': CareerIcon,
  'company-icon': CompanyIcon,
  'contact-us-icon': ContactUsIcon,
  'cn-badge-icon': CnBadge,
  'easy-and-fast-icon': EasyAndFast,
  'existing-financing-icon': ExistingFinancingIcon,
  'first-trade-free-icon': FirstTradeFree,
  'globe-icon': GlobeIcon,
  'grow-together-icon': GrowTogether,
  'grow-your-business-icon': GrowYourBusiness,
  'hand-shake-icon': HandShake,
  'help-icon': HelpIcon,
  'improve-every-day-icon': ImproveEveryDay,
  'letter-icon': LetterIcon,
  'make-customer-happy-icon': MakeCustomersHappy,
  'make-it-happen-icon': MakeItHappen,
  'modifi-pays-seller': ModifiPaysSeller,
  'money-icon': MoneyIcon,
  'multiple-docs-icon': MultipleDocsIcon,
  'news-icon': NewsIcon,
  'no-collateral-icon': NoCollateral,
  'no-paperwork-icon': NoPaperwork,
  'own-your-actions-icon': OwnYourActions,
  'partner-are-friends-icon': PartnersAreFriends,
  'payment-extensions-icon': PaymentExtensions,
  'payment-flexibility-icon': PaymentFlexibility,
  'payfor-icon': PayforIcon,
  'people-icon': PeopleIcon,
  'pin-location-icon': PinLocationIcon,
  'products-extend-icon': ProductsExtend,
  'products-order-icon': ProductsOrder,
  'products-payments-icon': ProductsPayment,
  'products-payout-icon': ProductsPayout,
  'products-register-icon': ProductsRegister,
  'products-repayment-icon': ProductsRepayment,
  'products-shipment-icon': ProductsShipment,
  'push-the-boundaries-icon': PushTheBoundaries,
  'quick-and-easy-icon': QuickAndEasy,
  'register-icon': Register,
  'region-icon': RegionIcon,
  'risk-coverage-icon': RiskCoverage,
  'risk-icon': RiskIcon,
  'sf-icon': SFIcon,
  'shipment-icon': ShipmentIcon,
  'shipment-of-goods-icon': ShipmentOfGoods,
  'straight-talking-icon': StraightTalking,
  'there-for-you-icon': ThereForYou,
  'trade-icon': TradeIcon,
  'transparent-icon': Transparent,
  'verified-user-icon': VerifiedUserIcon,
}
